import styled from "styled-components";


export const StyledHero = styled.header`
  display: flex;
  flex-direction: column;
  padding: 1em;
  margin: 0 auto;
  & > h1 {
    display: block;
    margin-top: 2.5em;
    margin-bottom: 1em;
    font-size: 2.3em;
    line-height: 1.2;
    font-weight: bold;
  }
  & > section {
    line-height: 1.5;
    max-width:900px;
    margin:0 auto;
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
    section {
      padding: 0 60px 0 60px;
    }
    h1,
    section {
      text-align: center;
    }
    div {
      margin: 0 auto;
      flex-direction: row;
      gap: 1em;
      justify-content: space-around;
    }
     
    
  }
`;